import get from 'lodash.get';

const getTermsOfUseUrl = (rootState) => get(rootState, 'user.partnerData.properties.tosUrl', null);

export default getTermsOfUseUrl;
